export function CheckboxInput({ label, text, onChange }) {
  function handleChange({ target }) {
    onChange(target.checked);
  }

  return (
    <div className="root">
      <div className="label">{label}</div>
      <label className="checkboxContainer">
        <input
          className="checkboxContainer__checkbox"
          type="checkbox"
          onChange={handleChange}
        />
        <span className="checkboxContainer__text">{text}</span>
      </label>
      <style jsx>{`
        .root {
          margin-bottom: 18px;
        }

        .label {
          margin-bottom: 9px;
          display: block;
          font-weight: 600;
          color: var(--bgBlueish__text);
        }

        .checkboxContainer {
          display: flex;
        }

        .checkboxContainer__checkbox {
          margin: 4px 9px 0 0;
        }

        .checkboxContainer__text {
          font-weight: 500;
          color: var(--bgBlueish__text);
          line-height: 1.3;
        }
      `}</style>
    </div>
  );
}
